module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"createMeasureTitle":"Massnahme erstellen","scenarioMeasureTitle":"Szenario-Massnahme","scenarioEditedMeasureTitle":"Geplante Szenario-Massnahme","plannedMeasureTitle":"Geplante CAPEX-Massnahme","completedMeasureTitle":"Umgesetzte Massnahme","editScenarioMeasureTitle":"überarbeiten","editMeasureTitle":"bearbeiten"}}')
  delete Component.options._Ctor
}
